module.exports = __webpack_public_path__ + "static/templates/bulk-upload-en.32Y4gvq.xlsx";